import { IconButton, Tooltip } from '@mui/material'
import React from 'react'

const TableListActionButtons = ({downloadClick,shareClick,PrintClick,disabled=false}) => {
  return (
    <div>
    <Tooltip title="Share">
      <IconButton
            onClick={shareClick}
      >
        <i
          className="bi bi-share"
          style={{
            backgroundColor: "#9797e9",
          }}
        ></i>
      </IconButton>
    </Tooltip>

    <Tooltip title={disabled ? "Loading data..." : "Print"}>
        <IconButton
            className="printer-div"
            style={{ padding: "1px" }}
            onClick={PrintClick}
            disabled={disabled}
        >
            <i style={{ 
                backgroundColor: disabled ? "#cccccc" : "#d787e7",
                opacity: disabled ? 0.6 : 1
            }}
                className="bi bi-printer"
            ></i>
        </IconButton>
    </Tooltip>

    <Tooltip title="Download">
      <IconButton 
      onClick={downloadClick}
      style={{ paddingRight: "0px" }}
      >
        <i
          className="bi bi-arrow-down-circle"
          style={{backgroundColor: "rgb(255 118 133 / 69%)"}}
        ></i>
      </IconButton>
    </Tooltip>
  </div>
  )
}

export default TableListActionButtons